import PrivacyConsentCheckbox from "./privacyConsentCheckbox";
import ReferralConsentCheckbox from "./referralConsentCheckbox";
import VehicleConsentCheckbox from "./vehicleConsentCheckBox";
import MarketingConsentCheckbox from "./marketingConsentCheckbox";

export {PrivacyConsentCheckbox, ReferralConsentCheckbox, VehicleConsentCheckbox, MarketingConsentCheckbox};
